import { render, staticRenderFns } from "./OffDayLegend.vue?vue&type=template&id=0f0cd1d6&"
import script from "./OffDayLegend.vue?vue&type=script&lang=js&"
export * from "./OffDayLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f0cd1d6')) {
      api.createRecord('0f0cd1d6', component.options)
    } else {
      api.reload('0f0cd1d6', component.options)
    }
    module.hot.accept("./OffDayLegend.vue?vue&type=template&id=0f0cd1d6&", function () {
      api.rerender('0f0cd1d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/components/day-legend/OffDayLegend.vue"
export default component.exports